import styled from '@emotion/styled';
import { MatchFilter } from 'src/types/Match';
import LocaleSelect from './Select';

// Modal Styled Components
const LocaleList = styled.ul`
  list-style: none;

  margin: 0;
  padding: 0;

  background-color: ${({
  theme
}) => theme.color.surface2};
`;
const LocaleItem = styled.li`
  display: flex;
  align-items: center;

  color: #f8f8f8;
`;
const StyledSelect = styled(LocaleSelect)`
  flex-grow: 1;

  padding: 12px 0;
`;
interface Props {
  matchFilter: MatchFilter;
  values: string[];
  onChange: (key: string) => void;
  className?: string;
}
export default function LocalePreference({
  matchFilter,
  className,
  values,
  onChange
}: Props) {
  return <LocaleList className={className} data-sentry-element="LocaleList" data-sentry-component="LocalePreference" data-sentry-source-file="Preference.tsx">
      {matchFilter.filterOptions.map(({
      key,
      displayName
    }) => <LocaleItem key={key}>
          <StyledSelect name='locale' checked={values.includes(key)} value={key} label={displayName} onChange={() => onChange(key)} />
        </LocaleItem>)}
    </LocaleList>;
}